var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"14","fill":"none"}},_vm.$listeners),[_c('path',{attrs:{"fill":"#fff","d":"M0 10h8V8H0zm0 4h8v-2H0zm0-8h8V4H0zm0-6v2h8V0zm10 0h8v14h-8z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }